export default __webpack_public_path__ + "static/media/InstallationPdf.9acaf91e.txt";